import React from 'react';
import {Link} from 'react-router-dom';
import AurUserProfile from '../../../user-profile/AurUserProfile';

const UserProfile: React.FC = () => {
  const user = {name: 'Jim', surname: 'Carbone'};

  return (
    <>
      <div style={{marginBottom: '64px'}}>
        <h1>User Profile</h1>
        <Link to="/demo">Return</Link>
        <hr />
        <div style={{marginBottom: '32px'}}>
          <AurUserProfile user={user} />
        </div>
      </div>
    </>
  );
};

export default UserProfile;
